import { render } from "./ModalNewRegion.vue?vue&type=template&id=072d8945&scoped=true"
import script from "./ModalNewRegion.vue?vue&type=script&lang=js"
export * from "./ModalNewRegion.vue?vue&type=script&lang=js"

import "./ModalNewRegion.vue?vue&type=style&index=0&id=072d8945&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072d8945"]])

export default __exports__